import { defa } from 'defa-object';

const selectors = {
	application  : '[data-application=defa-language-selector]',
	menuContainer: '[data-container=dropdown]',
	btnTrigger   : '[data-click=menu-open]',
	btnLanguages : '[data-click=language]'
};

function LanguageSelector( element, l ) {
	element = element || selectors.application; // Default selector
	
	l                                            = l || {};
	let u = { enabled: !0 }, g, h, m, n, k, e, v = function ( a ) {
			a.preventDefault();
			a               = $( a.target ).closest( '[data-click]' );
			
			defa.objects.languageSettings.lang = a.attr('data-language');
			window.location.reload( !0 );
		}, w                                     = function ( a ) {
			a.preventDefault();
			p();
		},
		q                                        = function ( a ) {0 === $( a.target ).closest( selectors.application ).length && p();},
		p                                        = function () {
			e.toggleClass( 'open' );
			setTimeout( function () {
				if ( e.hasClass( 'open' ) ) {
					k.on( 'click', q );
				} else {
					k.off( 'click', q );
				}
			}, 50 );
		}, x                                     = function () {
			let a = '';
			_.each( defa.vars.languages, function ( b ) {
				a += `<li><a href="#" data-click="language" data-language="${b.languageCode}">` +
					 `<img class="in" src="assets/style/gfx/flags/${b.flag}"/>` +
					 `<img class="out" src="assets/style/gfx/flags/${b.flag}"/>` +
					 `<span>${b.languageName}</span>` +
					 '</a></li>';
			
			} );
			$( selectors.menuContainer ).append( a );
		}, r                                     = function () {
			e.removeClass( 'open' );
			m.off( 'click' );
			n.off( 'click' );
			k.off( 'click', q );
			g.enabled && ( m.on( 'click', w ), n.on( 'click', v ) );
		};
	this.settings                                = function ( a ) {
		a && ( $.extend( g, a ), r() );
		return g;
	};
	this.closeMenu                               = function () {e.hasClass( 'open' ) && p();};
	( function ( a ) {
		g = $.extend( !0, {}, u, l );
		x();
		h = $( a );
		m = h.find( selectors.btnTrigger );
		k = $( document );
		e = h.find( selectors.menuContainer );
		n = h.find( selectors.btnLanguages );
		r();
	} )( element );
	return this;
}

export default LanguageSelector;